import { Checkbox } from '@progress/kendo-react-inputs'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { Typography } from '~/components/elements/Typography'
import { useFormField } from '~/hooks/useFormField'

import { type InputValues } from './utils'

export type ItemProps = {
  disabled: boolean
  index: number
}

export const Item = ({ disabled, index }: ItemProps) => {
  const { control } = useFormContext<InputValues>()
  const nameField = useFormField(control, `customerAttributes.${index}.name`)
  const checkedField = useFormField(
    control,
    `customerAttributes.${index}.checked`,
  )
  const checked = checkedField.value

  return (
    <>
      <Checkbox {...checkedField} disabled={disabled} />

      <Typography color={checked ? 'normal' : 'light'} variant="normal">
        {nameField.value}
      </Typography>
    </>
  )
}
